var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2d2d",
    d: "M3.538 3.668h1v7.664h-1zM.075 5.824h1v3.352h-1zM13.925 5.824h1v3.352h-1zM10.462 3.668h1v7.664h-1zM7 1.512h1v11.975H7z"
  })));
};

export { SvgMute as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYWQ0Y2Q1YzEtNzQ1Ni00N2VhLTkwZWUtZjc1ZTlhNGYzYmNiIiBkYXRhLW5hbWU9IkViZW5lIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiB2aWV3Qm94PSIwIDAgMTUgMTUiPjxyZWN0IHg9IjMuNTM4IiB5PSIzLjY2OCIgd2lkdGg9IjEiIGhlaWdodD0iNy42NjQiIGZpbGw9IiMyZDJkMmQiLz48cmVjdCB4PSIwLjA3NSIgeT0iNS44MjQiIHdpZHRoPSIxIiBoZWlnaHQ9IjMuMzUyIiBmaWxsPSIjMmQyZDJkIi8+PHJlY3QgeD0iMTMuOTI1IiB5PSI1LjgyNCIgd2lkdGg9IjEiIGhlaWdodD0iMy4zNTIiIGZpbGw9IiMyZDJkMmQiLz48cmVjdCB4PSIxMC40NjIiIHk9IjMuNjY4IiB3aWR0aD0iMSIgaGVpZ2h0PSI3LjY2NCIgZmlsbD0iIzJkMmQyZCIvPjxyZWN0IHg9IjciIHk9IjEuNTEyIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMS45NzUiIGZpbGw9IiMyZDJkMmQiLz48L3N2Zz4=";